module.exports = __webpack_public_path__ + "assets/mill-wright.svg?f3764abe15e9fa7c512270789e27807a";